import React from 'react';
import { 
    Modal, 
} from 'components/lib';

export function ActivityProgress({ onboard, setOnboard, onLocalStorage, leadList, campaignList, btnShowAlert, email }){
  const formFieldsOnboar_3 = {
    email_verified: {
      type: 'radio',
      options: [`Verificar correo eletrónico ${email}`]
    },
    domain: {
      type: 'radio',
      options: ['Indicar el correo electrónico con el cual se enviarán tus campañas'],
    },
    contacts: {
      type: 'radio',
      options: ['Importar tus contactos. (En caso de tenerlos)'],
    },
    first_campaign: {
      type: 'radio',
      options: ['Crea tu primera campaña'],
    }
  }

  return (
      <Modal 
          logo={onboard}
          title={'¡Un paso más!'}
          subtitle={'No olvides completar tu perfil empresarial'}
          text={'Es importante que el perfil de tu empresa se encuentre completo y actualizado'}
          form={formFieldsOnboar_3}
          type_form={onboard}
          onOnboard={setOnboard}
          initialize={true}
          close={true}
          onLocalStorage={onLocalStorage}
          leadList={leadList}
          campaignList={campaignList}
          btnShowAlert={btnShowAlert}
      /> 
  );
}